import { useRouter } from 'next/router'
import React, { ReactNode } from 'react'
import { render } from 'react-dom'
// import { fireGlobalSearchEvent } from '../../../helpers/filterHelper'
// import { ISearchFilterParams } from '../../../types/ISearchFilterParams'
// import { isMobile } from '../../../utils/utilities'
import PaginationStyles from './Pagination.css'

interface IPaginationState {
	numberOfPageLinks: number
}

interface IPaginationProps {
	nbPages: number | null
	currentPage: number | null
	space: number
}

export default function Pagination({
	nbPages,
	currentPage,
	space
}: IPaginationProps) {
	const router = useRouter()
	const { page } = router.query

	function renderPage() {
		if (!nbPages || nbPages === 1) return []
		let start = (currentPage ?? 0) + 1 - space
		if (start < 1) {
			start = 1
		}
		let end = (currentPage ?? 0) + 1 + space
		if (end > nbPages) {
			end = nbPages
		}
		let list: ReactNode[] = []
		for (let i = start; i <= end; i++) {
			list.push(
				<li
					key={i}
					className={`pagination__item ${
						Number(page ?? 0) === i - 1 ? 'active' : ''
					}`}
				>
					<div
						className='pagination__item-link'
						onClick={() => {
							router.push({
								pathname: router.pathname,
								query: {
									...router.query,
									page: i - 1
								}
							})
						}}
					>
						{i}
					</div>
				</li>
			)
		}
		return list
	}
	function renderPrev() {
		if (!currentPage || !page || Number(page) === 0) return
		if (currentPage > 0) {
			return (
				<li className='pagination__item'>
					<div
						className='pagination__item-link'
						onClick={() => {
							router.push({
								pathname: router.pathname,
								query: {
									...router.query,
									page: Number(page ?? 0) - 1
								}
							})
						}}
					>
						{'<'}
					</div>
				</li>
			)
		}
	}
	function renderGoToFirstPage() {
		if (currentPage && currentPage > 1) {
			return (
				<li className='pagination__item'>
					<div
						className='pagination__item-link'
						onClick={() => {
							router.push({
								pathname: router.pathname,
								query: {
									...router.query,
									page: 0
								}
							})
						}}
					>
						{'<<'}
					</div>
				</li>
			)
		}
	}
	function renderNext() {
		if (
			(currentPage ?? 0) + 1 === nbPages ||
			Number(page ?? 0) + 1 === nbPages
		)
			return

		return (
			<li className='pagination__item'>
				<div
					className='pagination__item-link'
					onClick={() => {
						router.push({
							pathname: router.pathname,
							query: {
								...router.query,
								page: Number(page ?? 0) + 1
							}
						})
					}}
				>
					{'>'}
				</div>
			</li>
		)
	}
	function renderGoToLastPage() {
		if (nbPages && currentPage === nbPages - 1) return
		if (nbPages && (currentPage ?? 0) < nbPages) {
			return (
				<li className='pagination__item'>
					<div
						className='pagination__item-link'
						onClick={() => {
							router.push({
								pathname: router.pathname,
								query: {
									...router.query,
									page: nbPages - 1
								}
							})
						}}
					>
						{'>>'}
					</div>
				</li>
			)
		}
	}
	return (
		<PaginationStyles>
			<ul className='pagination'>
				{renderGoToFirstPage()}
				{renderPrev()}
				{renderPage()}
				{renderNext()}
				{renderGoToLastPage()}
			</ul>
		</PaginationStyles>
	)
}
